import { useUser } from '@/hooks/v2/use-user';

import { AccountDetailsCard } from './components/account-details-card';

export default function Accounts() {
  const { account } = useUser();

  if (!account) {
    return <div>No account selected</div>;
  }

  return (
    <div>
      <AccountDetailsCard account={account} />
    </div>
  );
}
